module.exports = __webpack_public_path__ + "img/icon-thank-you.0f4b8bf3.png";